import { heroData } from '@/mocks/homeData';

export default function HeroSection() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, targetId: string) => {
    e.preventDefault();
    const target = document.querySelector(targetId);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-accent-50/40"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-sm font-medium mb-6">
              {heroData.tag}
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
              {heroData.h1}
            </h1>

            <p className="text-base md:text-lg text-foreground-600 font-medium mb-6">
              {heroData.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              {heroData.intro}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => handleScrollTo(e, '#ranking')}
                className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                探索热门内容
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#features"
                onClick={(e) => handleScrollTo(e, '#features')}
                className="px-8 py-3 rounded-full border border-background-300 text-foreground-700 font-medium text-sm hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20colorful%20geometric%20composition%20with%20soft%20flowing%20shapes%20and%20warm%20vibrant%20gradients%2C%20modern%20minimalist%20digital%20art%20style%2C%20video%20and%20media%20entertainment%20theme%2C%20dynamic%20curved%20elements%2C%20soft%20lighting%2C%20elegant%20atmospheric%20background%20with%20play%20button%20motifs&width=1400&height=1050&seq=tomato-hero-main&orientation=landscape"
                alt="番茄视频 - 聚合全网特色内容主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}